import React from "react";

class Tally extends React.Component {

    render() {
        return <iframe src="https://v47019.2281.tallyprimecloud.in" width={'100%'} height={650}/>;
    }
}
export default Tally;